module.exports = __webpack_public_path__ + "img/1.5dbdd1e4.jpg";